import { useState } from 'react';

import { Breadcrumb, Radio } from 'antd';
import { Link } from 'react-router';

import { DataSection } from '@/shared/components';
import { ROUTES } from '@/shared/consts';
import { usePageTitle } from '@/shared/hooks';
import { ESchoolType } from '@/shared/types';

import { CreateCorporateSchoolComponent } from './CreateCorporateSchoolComponent';
import { CreatePublicSchoolComponent } from './CreatePublicSchoolComponent';
import styles from './SchoolCreatePage.module.scss';

const SCHOOL_TYPE_TO_COMPONENT_MAPPER = {
  [ESchoolType.Public]: CreatePublicSchoolComponent,
  [ESchoolType.Corporate]: CreateCorporateSchoolComponent,
};

export const SchoolCreatePage = () => {
  usePageTitle('Создание школы');

  const [schoolType, setSchoolType] = useState(ESchoolType.Public);

  const Component = SCHOOL_TYPE_TO_COMPONENT_MAPPER[schoolType];

  return (
    <div className={styles.wrapper}>
      <Breadcrumb
        items={[
          { title: 'Публичные страницы' },
          {
            title: (
              <Link
                to={{
                  pathname: `/${ROUTES.PUBLIC_PAGES}/${ROUTES.SCHOOLS}`,
                }}
              >
                Школы
              </Link>
            ),
          },
          { title: 'Создание школы' },
        ]}
      />
      <DataSection
        titleText="Тип школы"
        isTitleRequired
      >
        <Radio.Group
          className={styles['type-wrapper']}
          options={[
            { label: 'Публичная', value: ESchoolType.Public },
            { label: 'Корпоративная', value: ESchoolType.Corporate },
          ]}
          value={schoolType}
          onChange={({ target: { value } }) => setSchoolType(value as ESchoolType)}
        />
      </DataSection>
      <Component schoolType={schoolType} />
    </div>
  );
};
